import * as React from "react";

import { StrategyPineDetailDialog } from "@/components/Strategies/StrategyPineDetailDialog";
import { Button } from "@/components/ui/button";

export type DeleteActivePinescriptDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isDeleting?: boolean;
  onConfirm: () => void;
};

const DELETE_MESSAGE =
  "Remove this composed TradingView Pinescript? You can compose again from a saved policy version.";

export function DeleteActivePinescriptDialog({
  open,
  onOpenChange,
  isDeleting = false,
  onConfirm,
}: DeleteActivePinescriptDialogProps): React.ReactElement {
  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen && isDeleting) return;
    onOpenChange(nextOpen);
  };

  const handleCancel = () => {
    if (isDeleting) return;
    onOpenChange(false);
  };

  return (
    <StrategyPineDetailDialog
      open={open}
      onOpenChange={handleOpenChange}
      title="Remove active Pinescript"
      showHeader={false}
      showDismissButton={false}
      showCornerClose={false}
      contentClassName="sm:max-w-md"
      bodyClassName="flex-none overflow-visible pt-0"
      contentProps={{ "data-strategy-active-pine-delete-dialog": "" }}
      footer={
        <div
          data-dashboard-layout-dialog-footer=""
          className="inline-flex max-w-full flex-wrap items-center justify-end gap-2"
        >
          <Button
            type="button"
            variant="outline-gray"
            size="sm"
            data-font="primary"
            className="shrink-0"
            disabled={isDeleting}
            onClick={handleCancel}
          >
            <span className="normal-case tracking-normal">Cancel</span>
          </Button>
          <Button
            type="button"
            variant="outline"
            size="sm"
            data-font="primary"
            data-trade-log-action="delete"
            className="shrink-0 border-destructive/40 text-destructive shadow-sm hover:bg-destructive/10 hover:text-destructive focus-visible:border-destructive/60 focus-visible:ring-destructive/25 dark:border-destructive/50 dark:hover:bg-destructive/15 [&_svg]:text-current"
            disabled={isDeleting}
            aria-busy={isDeleting || undefined}
            onClick={onConfirm}
          >
            <span data-font="primary" className="normal-case tracking-normal">
              {isDeleting ? "Removing…" : "Remove Pinescript"}
            </span>
          </Button>
        </div>
      }
    >
      <p className="font-[family-name:var(--font-primary)] text-sm font-normal text-gray-500 dark:text-white">
        {DELETE_MESSAGE}
      </p>
    </StrategyPineDetailDialog>
  );
}
